import "./style.scss";
import PasswordResetForm from "../../../common/PasswordResetForm";

const PasswordReset = () => {
    return (
        <div className="password-reset mx-auto col-md-6 align-middle mt-5">
            <PasswordResetForm withTitle={true} />
        </div>
    );
};

export default PasswordReset;
